import React from 'react';
import { lazyComponents } from '@src/utilities/LazyComponent';

WishlistIconComponent.displayName = 'theme__block-wishlist-icon';
export function WishlistIconComponent({ ...props }) {
    const WishlistButton = lazyComponents['WishlistButton'];

    return (
        <>
            <WishlistButton
                type="icon"
                settings={props.settings}
            />
        </>
    );
}

WishlistTextComponent.displayName = 'theme__block-wishlist-text';
export function WishlistTextComponent({ ...props }) {
    const WishlistButton = lazyComponents['WishlistButton'];

    return (
        <WishlistButton
            type="text"
            settings={props.settings}
        />
    );
}
